export const createTableOptions = (maxRows = 10, maxCols = 10) => {
    const tableOptions = [];
    for (let r = 1; r <= maxRows; r++) {
        for (let c = 1; c <= maxCols; c++) {
            tableOptions.push("newtable_" + r + "_" + c);
        }
    }
    return tableOptions
}



// WEBPACK FOOTER //
// ./src/helpers/tableOptions.helper.js